import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {DataProviderService} from "@app/data-provider.service";
import {Observable} from "rxjs";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {Router} from "@angular/router";

@Injectable({ providedIn: 'root' })
export class LoginService {
    private serviceUrl: string;

    constructor(
        public http: HttpClient,
        private dataProviderService: DataProviderService,
        private router: Router,
    ) { this.serviceUrl = this.dataProviderService.getServiceUrl() + 'login'; }

    public iniciarSesion(email: string, passwd: string): Observable<any> {
        const header = new HttpHeaders().set('Content-Type', 'application/json');
        const elementoDTO = {
            email: email,
            passwd: passwd,
        };
        return this.http.put(this.serviceUrl, JSON.stringify(elementoDTO), {headers: header})
            .pipe(
                catchError((err) => {
                    if (err.status === 403 && err.error && err.error.error === 'REQUIRE_PASSWORD_CHANGE') {
                        sessionStorage.setItem('pendingPasswordChange', JSON.stringify({ email, passwd }));
                        this.router.navigate(['/auth/cambiar-password']);
                    }
                    return throwError(err);
                })
            )
            .map((res) => {
                localStorage.setItem('token', String(res['token']));
                return res;
            });
    }

    public getUserInfo(userId) {
        return this.http.get(this.serviceUrl + '/' + userId, this.dataProviderService.authHeader())
            .toPromise()
            .then((res) => {
                return res;
            })
            .catch(this.handleError);
    }

    public closeSession() {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        return this.http.delete(this.serviceUrl, this.dataProviderService.authHeader())
            .toPromise()
            .then((res) => {
                return res;
            })
            .catch(this.handleError);
    }

    public cambiarPasswordForzado(email: string, passwd: string, newPasswd: string): Observable<any> {
        const header = new HttpHeaders().set('Content-Type', 'application/json');
        const url = this.dataProviderService.getServiceUrl() + 'cambiar-password-forzado';
        return this.http.put(url, JSON.stringify({ email, passwd, newPasswd }), { headers: header });
    }

    private handleError(error: any): Promise<any> {
        // console.error('An error occurred', error.error); // for demo purposes only
        return Promise.reject(error);
    }
}


